<template>
  <div class="drop-action d-inline-block">
    <base-dropdown
      menu-on-right
      class="nav-item"
      tag="li"
      title-tag="a"
      title-classes="dropnocaret"
      title="Actions"
      :direction="direction"
      v-if="itemClass === 'Transfers'"
    >
      <span slot="title"> <i class="flaticon-bold-kebab"></i></span>
      <template v-if="record.stage === 'QUOTE'">
        <div
          class="dropdown-item"
          v-if="canConvertQuote(record.status)"
          @click="convertToBooking(record._id, convertQuoteToBookingById)"
        >
          <span class="icon-action">
            <i class="flaticon-right-4 text-confirmed"> </i>
            Convert to Reservation
          </span>
        </div>
        <div
          class="dropdown-item"
          v-if="canDownloadQuotePDF(record.status)"
          @click="
            downloadQuotePDF(
              record._id,
              record.booking_number,
              downloadQuoteById
            )
          "
        >
          <span class="icon-action">
            <i class="flaticon-web-bill-2"></i>Download Quote
          </span>
        </div>
        <div
          class="dropdown-item"
          v-if="canDuplicateQuote(record.status)"
          @click="duplicateQuote(record._id, duplicateQuoteById)"
        >
          <span class="icon-action">
            <i class="flaticon-copy"></i>Duplicate
          </span>
        </div>
        <div
          class="dropdown-item"
          v-if="canCancelQuote(record.status)"
          @click="cancelQuote(record._id, cancelQuoteById)"
        >
          <span class="icon-action">
            <i class="flaticon-remove text-cancelled"></i> Cancel
          </span>
        </div>
        <div
          class="dropdown-item"
          @click="deleteQuote(record._id, deleteQuoteById)"
        >
          <span class="icon-action">
            <i class="flaticon-delete text-danger"></i>Delete
          </span>
        </div>
      </template>
      <template v-else>
        <div
          class="dropdown-item"
          v-if="
            canUserChangeStatus &&
              canConfirmBooking(
                record.status,
                record.status_update,
                record.owner
              )
          "
          @click="confirmBooking(record._id, confirmReservationById)"
        >
          <span class="icon-action">
            <i class="flaticon-bold-check-3 text-confirmed"> </i>
            Confirm
          </span>
        </div>
        <div
          class="dropdown-item"
          v-if="canUserChangeStatus && canCancelBooking(record.status)"
          @click="
            handlerCancelReservation(
              record._id,
              record.pickup_date,
              record.branch.timezone,
              record.service.cancellationPolicy,
              cancelBookingById
            )
          "
        >
          <span class="icon-action">
            <i class="flaticon-remove text-cancelled"></i> Cancel
          </span>
        </div>
        <div
          class="dropdown-item"
          v-if="
            canUserChangeStatus &&
              canCompleteBooking(record.status) &&
              calculateHoursDifference(
                record.pickup_date,
                record.branch.timezone
              ) >= 1
          "
          @click="completeBooking(record._id, updateBookingStatus)"
        >
          <span class="icon-action">
            <i class="flaticon-check text-completed"></i> Complete
          </span>
        </div>

        <div
          class="dropdown-item"
          v-if="
            canUserChangeStatus &&
              canMarkBookingAsNoShow(record.status) &&
              calculateHoursDifference(
                record.pickup_date,
                record.branch.timezone
              ) >= 1
          "
          @click="noShowBooking(record._id, updateBookingStatus)"
        >
          <span class="icon-action">
            <i class="flaticon-no-group text-no-show"></i> Mark as No Show
          </span>
        </div>
        <div
          class="dropdown-item"
          v-if="
            canUserMarkBookingAsPaid &&
              canMarkBookingAsPaid(record.status, record.payment_status)
          "
          @click="
            handlerMarkReservationsAsPaid([record], markReservationsAsPaidById)
          "
        >
          <span class="icon-action">
            <i class="flaticon-invoice text-confirmed"></i> Mark as Paid
          </span>
        </div>

        <div class="dropdown-divider" v-if="record.status != 'JF'"></div>

        <div
          class="dropdown-item"
          v-if="canResendBookingEmail(record.status)"
          @click="
            resendNotifications(
              record._id,
              record.status,
              record.class,
              record.isProssesing,
              resendEmailNotificationByBookingId
            )
          "
        >
          <span class="icon-action">
            <i class="flaticon-envelope text-orange"></i> Resend Email
          </span>
        </div>

        <div
          class="dropdown-item"
          v-if="canDownloadQuote(record.status)"
          @click="
            downloadPDFType(
              record._id,
              record.booking_number,
              record.product,
              'quote',
              record.agent ? record.agent : record.customer
            )
          "
        >
          <span class="icon-action">
            <i class="flaticon-web-bill-2"></i>Download Quote
          </span>
        </div>

        <div
          class="dropdown-item"
          v-if="canDownloadVoucher(record.status)"
          @click="
            downloadPDFType(
              record._id,
              record.booking_number,
              record.product,
              'voucher',
              record.agent ? record.agent : record.customer
            )
          "
        >
          <span class="icon-action">
            <i class="flaticon-web-bill-2"></i>Download Voucher
          </span>
        </div>

        <div
          class="dropdown-item"
          @click="
            canUserCreate && duplicateBooking(record._id, duplicateBookingById)
          "
        >
          <span class="icon-action">
            <i class="flaticon-copy"></i>Duplicate
          </span>
        </div>

        <div class="dropdown-divider" v-if="record.status != 'SC'"></div>

        <div
          class="dropdown-item"
          v-if="canUserDelete"
          @click="deleteBooking(record._id, deleteBookingById)"
        >
          <span class="icon-action">
            <i class="flaticon-delete text-danger"></i>Delete
          </span>
        </div>
      </template>
    </base-dropdown>
    <base-dropdown
      menu-on-right
      class="nav-item"
      tag="li"
      title-tag="a"
      title-classes="dropnocaret"
      title="Actions"
      :direction="direction"
      v-else
    >
      <span slot="title"> <i class="flaticon-bold-kebab"></i></span>
      <div
        class="dropdown-item"
        v-if="canUserChangeStatus && ['ON_HOLD'].includes(record.status)"
        @click="confirmBooking(record._id, otaConfirmReservationById)"
      >
        <span class="icon-action">
          <i class="flaticon-bold-check-3 text-confirmed"> </i>
          Confirm
        </span>
      </div>
      <div
        class="dropdown-item"
        v-if="
          canUserMarkBookingAsPaid &&
            canMarkBookingAsPaid(record.status, record.payment)
        "
        @click="
          handlerMarkReservationsAsPaid([record], markReservationsAsPaidById)
        "
      >
        <span class="icon-action">
          <i class="flaticon-invoice text-confirmed"></i> Mark as Paid
        </span>
      </div>
      <div
        class="dropdown-item"
        v-if="
          canUserChangeStatus &&
            ['ON_HOLD', 'CONFIRMED'].includes(record.status)
        "
        @click.stop="otaCancelBooking(record._id, cancelExperienceReservation)"
      >
        <span class="icon-action">
          <i class="flaticon-remove text-cancelled"></i> Cancel
        </span>
      </div>

      <div
        class="dropdown-item"
        v-if="['CONFIRMED'].includes(record.status)"
        @click="
          resendNotifications(
            record._id,
            record.status,
            record.class,
            false,
            resendEmailNotificationByBookingId
          )
        "
      >
        <span class="icon-action">
          <i class="flaticon-envelope text-orange"></i> Resend Email
        </span>
      </div>

      <div
        class="dropdown-item"
        v-if="['CONFIRMED'].includes(record.status)"
        @click="
          downloadPDFType(
            record._id,
            record.booking_number,
            record.product,
            'voucher',
            record.agent ? record.agent : record.customer
          )
        "
      >
        <span class="icon-action">
          <i class="flaticon-web-bill-2"></i> Download Voucher
        </span>
      </div>

      <div
        class="dropdown-item"
        v-if="['CONFIRMED'].includes(record.status)"
        @click.stop="
          downloadTickets(
            record._id,
            record.agent ? record.agent : record.customer,
            record.booking_number
          )
        "
      >
        <span class="icon-action">
          <i class="flaticon-web-tickets"></i> Download Tickets
        </span>
      </div>
      <div
        class="dropdown-item"
        v-if="canUserDelete && ['CANCELLED', 'EXPIRED'].includes(record.status)"
        @click="deleteBooking(record._id, deleteBookingById)"
      >
        <span class="icon-action">
          <i class="flaticon-delete text-danger"></i>Delete
        </span>
      </div>
    </base-dropdown>
  </div>
</template>

<script>
import moment from "moment-timezone";
import lodash from "lodash";
import { mapGetters, mapMutations } from "vuex";
import { QuotesAPI, ReservationsAPI, PaymentsAPI } from "@/core/api";
import {
  calculateHoursDifference,
  canCancelBooking,
  cancelBooking,
  canCompleteBooking,
  canConfirmBooking,
  canDownloadQuote,
  canDownloadVoucher,
  canMarkBookingAsNoShow,
  canMarkBookingAsPaid,
  canResendBookingEmail,
  completeBooking,
  confirmBooking,
  deleteBooking,
  duplicateBooking,
  hasBookingsWithPaymentLink,
  hasCanceledBookings,
  hasExpiredBookings,
  hasPaidBookings,
  markReservationsAsPaid,
  noShowBooking,
  otaCancelBooking,
  resendNotifications,
  resolveRefundEligibility
} from "@/helpers/reservation.helpers";
import { setSigOut } from "@/helpers/commons.helpers";
import {
  canCancelQuote,
  canConvertQuote,
  canDownloadQuotePDF,
  canDuplicateQuote,
  cancelQuote,
  convertToBooking,
  deleteQuote,
  downloadQuotePDF,
  duplicateQuote
} from "@/helpers/quote.helpers";
export default {
  name: "ReservationRowActions",
  props: {
    record: {
      type: Object,
      required: true
    },
    itemClass: {
      type: String,
      default: ""
    },
    direction: {
      type: String,
      default: "down"
    },
    canUserChangeStatus: {
      type: Boolean,
      default: false
    },
    canUserMarkBookingAsPaid: {
      type: Boolean,
      default: false
    },
    canUserCreate: {
      type: Boolean,
      default: false
    },
    canUserDelete: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ...mapMutations(["setLoad", "setSigOut"]),
    // Status-check helpers for quotes, passed straight through to the template
    canCancelQuote,
    canConvertQuote,
    canDownloadQuotePDF,
    canDuplicateQuote,
    // Confirmation-dialog helpers for quotes, called directly from the template, exactly
    cancelQuote,
    convertToBooking,
    deleteQuote,
    downloadQuotePDF,
    duplicateQuote,

    // Status-check helpers passed straight through to the template
    canConfirmBooking,
    canCancelBooking,
    canCompleteBooking,
    canMarkBookingAsNoShow,
    canMarkBookingAsPaid,
    canResendBookingEmail,
    canDownloadQuote,
    canDownloadVoucher,
    calculateHoursDifference,

    // Confirmation-dialog helpers called directly from the template, exactly
    // as they were inlined on the host page before this was a component.
    confirmBooking,
    completeBooking,
    noShowBooking,
    otaCancelBooking,
    resendNotifications,
    duplicateBooking,
    deleteBooking,

    async handlerCancelReservation(
      bookingId,
      pickupDate,
      timeZone,
      cancellationPolicy,
      callback
    ) {
      const utcNow = moment.tz(timeZone).utc(true);
      let refundEligibility = resolveRefundEligibility(
        utcNow,
        pickupDate,
        cancellationPolicy
      );
      await cancelBooking(bookingId, refundEligibility, callback);
    },
    async handlerMarkReservationsAsPaid(bookings, callback) {
      const validationRules = [
        {
          check: hasPaidBookings,
          message:
            "You are trying to pay one or more reservations which have been paid"
        },
        {
          check: hasCanceledBookings,
          message:
            "You are trying to pay one or more reservations which have been cancelled"
        },
        {
          check: hasBookingsWithPaymentLink,
          message:
            "One or more of the selected reservations contains a valid payment link, wait until the payment link has expired"
        },
        {
          check: hasExpiredBookings,
          message:
            "You are trying to pay one or more reservations with an expired rate."
        }
      ];

      for (const rule of validationRules) {
        if (rule.check(bookings)) {
          this.$notify({
            type: "warning",
            title: "The Reservations cannot be Paid!",
            message: rule.message,
            icon: "flaticon-warning-1"
          });
          return;
        }
      }
      const payload = {
        line_items: bookings.map(booking => {
          return {
            unit_id: booking._id
          };
        }),
        reason: "Payment marked as paid by admin"
      };
      await markReservationsAsPaid(payload, callback);
    },
    async markReservationsAsPaidById(payload) {
      try {
        this.setLoad(true);
        let { data } = await PaymentsAPI.markReservationsAsPaid(
          payload,
          this.sesion.token
        );
        this.setLoad(false);
        if (!data) {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Reservations cannot be Paid",
            icon: "flaticon-remove"
          });
          return;
        }
        this.$notify({
          type: "success",
          title: "Success!",
          message: "The Reservations has been Paid",
          icon: "flaticon-check-3"
        });
        this.$emit("updated");
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "The Reservation cannot be Paid");
      }
    },

    // ---- API calls (moved from the host page so this component is
    // self-sufficient and reusable across pages) ----
    handleError(error, message, title = "Error!") {
      if (error.response) {
        let { data } = error.response;
        if (data.code === 401) {
          let auth = setSigOut(error);
          if (auth) {
            this.setSigOut(true);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$notify({
          type: "danger",
          title: title,
          message: message,
          icon: "flaticon-remove"
        });
      }
    },
    async confirmReservationById(reservationId) {
      try {
        this.setLoad(true);
        let { data } = await ReservationsAPI.confirmReservationById(
          reservationId,
          {},
          this.sesion.token
        );
        this.setLoad(false);
        if (data) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Reservation has been Confirmed",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Reservation cannot be Confirmed",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "The Reservation cannot be Confirmed");
      }
    },
    async otaConfirmReservationById(reservationId) {
      try {
        this.setLoad(true);
        let { data } = await ReservationsAPI.confirmExperienceReservationById(
          reservationId,
          {},
          this.sesion.token
        );
        this.setLoad(false);
        if (!data) {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Reservation cannot be Confirmed",
            icon: "flaticon-remove"
          });
          return;
        }

        this.$notify({
          type: "success",
          title: "Success!",
          message: "The Reservation has been Confirmed",
          icon: "flaticon-check-3"
        });
        return;
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "The Reservation cannot be Confirmed");
      }
    },
    async cancelBookingById(bookingId, reason) {
      try {
        this.setLoad(true);
        let { data } = await ReservationsAPI.canlcelReservationById(
          bookingId,
          reason,
          this.sesion.token
        );
        this.setLoad(false);
        if (!data) {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Reservation can't be Cancelled",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "The Reservation can't be cancelled");
      }
    },
    async cancelExperienceReservation(bookingId, reason = "") {
      try {
        this.setLoad(true);
        let { data } = await ReservationsAPI.cancelExperienceReservationById(
          bookingId,
          { reason: reason },
          this.sesion.token
        );
        this.setLoad(false);
        if (!data) {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Reservation cannot be Cancelled",
            icon: "flaticon-remove"
          });
          return;
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "The Reservation cannot be Cancelled");
      }
    },
    async updateBookingStatus(reservationId, status, reason = "") {
      try {
        this.setLoad(true);
        let { data } = await ReservationsAPI.changeRservationStatus(
          reservationId,
          status,
          reason,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The reservation have been completed successfully",
            icon: "flaticon-check-3"
          });
          this.$emit("updated");
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The reservation could not be completed",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async resendEmailNotificationByBookingId(bookingId, recipients = []) {
      try {
        this.setLoad(true);
        let { data } = await ReservationsAPI.resendEmailToUsersByReservationId(
          bookingId,
          recipients,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The notifications have been forwarded successfully",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The notifications couldn't be sent",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The operation couldn't be completed. Please try again"
        );
      }
    },
    async duplicateBookingById(bookingId, populate) {
      if (!populate) {
        return;
      }
      this.$router.push(`/reservations/new?recordId=${bookingId}`);
    },
    async downloadPDFType(bookingId, reference, isTransfer, pdfType, client) {
      try {
        let voucherType = isTransfer ? "product" : "transfer";
        this.setLoad(true);
        let { data } = await ReservationsAPI.downloadPDF(
          pdfType,
          bookingId,
          client,
          voucherType
        );
        this.setLoad(false);
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Voucher(${reference}).pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        this.setLoad(false);
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The data was not download. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    async downloadTickets(bookingId, client, reference) {
      try {
        this.setLoad(true);
        let { data } = await ReservationsAPI.downloadPDFTickets(
          bookingId,
          client,
          "ALL",
          null
        );
        this.setLoad(false);
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Tickets(${reference}).pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        this.setLoad(false);
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The data was not download. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    async deleteBookingById(bookingId) {
      try {
        this.setLoad(true);
        let { data } = await ReservationsAPI.deleteReservation(
          bookingId,
          this.sesion.token
        );
        this.setLoad(false);
        if (!data) {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Reservation cannot be Deleted!",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    /**
     *
     * Quote Action Methods
     */
    async cancelQuoteById(quoteId, reason = "") {
      try {
        this.setLoad(true);
        let { data } = await QuotesAPI.cancelQuoteById(
          quoteId,
          this.sesion.token
        );
        this.setLoad(false);
        if (!data) {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Quote can't be Cancelled",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "The Quote can't be cancelled");
      }
    },
    async convertQuoteToBookingById(quoteId) {
      try {
        this.setLoad(true);
        let { data } = await QuotesAPI.createBookingFromQuoteById(
          quoteId,
          this.sesion.token
        );
        this.setLoad(false);
        if (data) {
          const { _id: id } = data;
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Quote has been converted to a Booking",
            icon: "flaticon-check-3"
          });
          this.$router.push(`/reservations/${id}`);
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Quote cannot be converted to a Booking",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "The Quote cannot be converted to a Booking");
      }
    },
    async duplicateQuoteById(quoteId, populate) {
      if (!populate) {
        return;
      }
      this.$router.push(`/reservations/new-quote?recordId=${quoteId}`);
    },
    async downloadQuoteById(quoteId, quoteNumber) {
      try {
        this.setLoad(true);
        let { data } = await QuotesAPI.downloadQuotePDFById(
          quoteId,
          this.sesion.token
        );
        this.setLoad(false);
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Quote(${quoteNumber}).pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async deleteQuoteById(quoteId) {
      try {
        this.setLoad(true);
        let { data } = await QuotesAPI.deleteQuoteById(
          quoteId,
          this.sesion.token
        );
        this.setLoad(false);
        if (!data) {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Quote cannot be deleted!",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    }
  },
  computed: {
    ...mapGetters(["sesion"])
  }
};
</script>
